import * as React from "react";
import { Stethoscope, ShieldCheck, Activity, BookOpen, Video, FlaskConical, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const servicesData = [{
  title: "درمان اضطراب و استرس",
  description: "ارائه راهکارهای علمی و روانشناختی برای مدیریت تنش‌های روزمره و بازیابی آرامش درونی.",
  icon: ShieldCheck
}, {
  title: "روانشناسی میگرن و درد",
  description: "تعدیل الگوهای ذهنی موثر بر دردهای مزمن و میگرن با رویکردهای نوین روان‌تنی.",
  icon: Activity
}, {
  title: "مشاوره کودک و نوجوان",
  description: "همراهی تخصصی در مسیر رشد فرزندان و حل چالش‌های رفتاری و هیجانی دوران بلوغ.",
  icon: BookOpen
}, {
  title: "درمان وسواس (OCD)",
  description: "به‌کارگیری متدهای شناختی-رفتاری برای رهایی از افکار تکرار شونده و رفتارهای وسواسی.",
  icon: Stethoscope
}, {
  title: "مشاوره فردی و افسردگی",
  description: "ایجاد فضایی امن برای واکاوی احساسات و بازگشت به مسیر پویایی و نشاط زندگی.",
  icon: Video
}, {
  title: "روابط والد و فرزند",
  description: "بهبود مهارت‌های ارتباطی در خانواده و تقویت پیوندهای عاطفی میان والدین و فرزندان.",
  icon: FlaskConical
}];
export default function OurCarePathways() {
  return <section data-section-id="240553" id="حوزههای-تخصصی-درمان" className="relative py-24 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/10 blur-[120px]" />
        <div className="absolute -bottom-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-primary/5 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default text-foreground mb-6 tracking-tight">
            حوزه‌های تخصصی درمان
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-default">
            تلفیق دانش تخصصی با رویکردی همدلانه برای ارائه خدمات روانشناختی متناسب با نیازهای منحصر‌به‌فرد شما.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {servicesData.map((service, i) => <Card key={i} data-index={i} className="group relative overflow-hidden bg-card/60 backdrop-blur-xl border-border/40 shadow-md hover:shadow-lg hover:bg-secondary/5 transition-all duration-500 rounded-2xl">
              <CardHeader className="pb-4">
                <div className="w-14 h-14 rounded-xl bg-background/90 shadow-sm border border-border/20 flex items-center justify-center mb-6 group-hover:-translate-y-2 transition-transform duration-500 ease-out">
                  <service.icon className="w-7 h-7 text-secondary" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-default text-2xl text-foreground leading-tight font-bold">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed font-default">
                  {service.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button variant="link" asChild className="text-base font-medium text-secondary hover:text-secondary/80 group h-auto p-0">
            <Link to="/SpecializedAreasPage" className="inline-flex items-center gap-2">
              مشاهده تمامی خدمات
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1.5 transition-transform duration-300 ease-out" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}